import React from 'react';
import { Shimmer, ShimmerElementType } from '@fluentui/react';

export const radiusShimmerElement = [
  { type: ShimmerElementType.line, width: 20, height: 20 },
  { type: ShimmerElementType.gap, width: 5 },
  { type: ShimmerElementType.line, height: 16, width: 300 },
  { type: ShimmerElementType.gap, height: 20, width: '100%' },
];

export const RadiusShimmer = () => (
  <Shimmer shimmerElements={radiusShimmerElement} />
);
